import Service from './Service';
import User from '../core/user';

class InstitutionService {
  constructor(props) {
    this.PATH = {
      TOTAL_ACTIVITY: 'c/xm/show/toc/list',
      MINE_ACTIVITY: 'c/xm/show/toc/my/list', // 我参加过的
      INSTITUTION_DETAIL: 'c/institution/getInstitutionDetail',
      INSTITUTION_MICRO: 'anon/oldWebsite/getAllInfo',
      TRIAL_LESSON: 'anon/course/trialBook',
      INSTITUTION_ALBUM: 'c/instAlbum/getInstAlbumList',
      INSTITUTION_DYNAMIC: 'public/esCommon/pageList',
      INSTITUTION_RECORD_LIST: 'public/esCommon/collectDocmentList', // 成长档案列表,
      INSTITUTION_UNREAD_MESSAGE: 'public/institution/getInstUnreadMsgNumber',
      SUPER_INSTITUTION_LIST: 'public/institution/getSuperInst', //高级版机构列表
      INSTITUTION_ALBUM_MESSAGR: 'public/electronAlbum/queryNoReadAlbumCount',
      GET_MARKETING_STATUS: 'anon/commonMicroWebsite/getMarketingStatus', // 获取微官网关联入口开启状态
      GENERATE_CODE_URL:'anon/commonMicroWebsite/generateSceneTicket', // 生成微官网太阳码
      INSTITUTION_SUB_TEMPLATE: 'public/wechat/getInstSubTemplate',  // 获取高级版机构消息订阅模板ID
    };
  }

  /**
   * 获取机构活动
   * @param instId
   * @param pageNo
   * @param pageSize
   * @param success
   * @param error
   */
  getInstTotalActivityList(instId, pageNo) {
    const params = {
      instId,
      pageNo,
      pageSize: 10
    }
    return Service.doAsyncRequest(this.PATH.TOTAL_ACTIVITY, {
      params: params
    });
  }

  getMineActivityList(instId, pageNo) {
    const params = {
      instId,
      pageNo,
      pageSize: 10
    }
    return Service.doAsyncRequest(this.PATH.MINE_ACTIVITY, {
      params: params
    });
  }

  getInstitutionDetail(instId) {
    const params = {
      instId: instId
    };
    return Service.doAsyncRequest(this.PATH.INSTITUTION_DETAIL, {
      params: params
    });
  }

  getInstMicroSiteInfo(id) {
    return axios.Sales(this.PATH.INSTITUTION_MICRO,{ instId: id});
  }

  getInstAlbumMsg() {
    return axios.Zeus(this.PATH.INSTITUTION_ALBUM_MESSAGR);
  }


  bookLesson(instId, name, phone, remark) {
    const params = {
      instId: instId,
      name: name,
      phone: phone,
      remark: remark
    };
    return axios.Customer(this.PATH.TRIAL_LESSON, params)
  }

  getInstitutionAlbum(instId) {
    const params = {
      instId
    };
    return Service.doAsyncRequest(this.PATH.INSTITUTION_ALBUM, {
      params
    });
  }

  getInstitutionDynamicList(params) {
    return axios.Zeus(this.PATH.INSTITUTION_DYNAMIC, params);
  }

  getInstitutionSubTemplate(instId) {
    const param = {
      instId
    };
    return axios.Zeus(this.PATH.INSTITUTION_SUB_TEMPLATE, param);
  }

  // 我的收藏
  getMineRecordList(params) {
    return axios.Zeus(this.PATH.INSTITUTION_RECORD_LIST, params)
  }

  // c端首页未读消息条数
  getUnreadMessageCount() {
    return axios.Customer(this.PATH.INSTITUTION_UNREAD_MESSAGE)
  }

  // 微官网获取高级机构列表
  getSuperInstList(params) {
    return axios.Customer(this.PATH.SUPER_INSTITUTION_LIST, params)
  }

  // 微官网获取高级机构列表
  getMarketingStatus(params) {
    return axios.Sales(this.PATH.GET_MARKETING_STATUS, params)
  }

  // 微官网获取高级机构列表
  generateCodeUrl(params) {
    return axios.Sales(this.PATH.GENERATE_CODE_URL, params)
  }
};

export default new InstitutionService();



// WEBPACK FOOTER //
// ./src/service/InstitutionService.js